<p500-ui-many-items
  [data]="conditionsData"
  [title]="title"
  [tmpl]="tmpl"
  [buttonTmpl]="previewTmpl"
  [previewTmpl]="buttonTmpl"
></p500-ui-many-items>
<ng-template let-data="data" #tmpl>
  <ng-container *ngIf="data && data.field?.length; else emptyTmpl">
    <div class="d-flex">
      <span>{{ conditionsLocalization[data?.label] ?? data?.label }}</span
      >&nbsp; <span>{{ signsLocalization.get(data?.operator) ?? data?.operator }}</span
      >&nbsp;
      <ng-container [ngSwitch]="data?.field">
        <ng-container *ngIf="!booleanFields.has(data?.field)">
          <span *ngFor="let value of data?.values" class="ml-4 c-card__condition">
            <gtd-ui-field-default-country *ngSwitchCase="'Country'" [data]="value"></gtd-ui-field-default-country>
            <gtd-ui-field-dynamic
              *ngSwitchCase="'Offer'"
              [type]="'offer'"
              [data]="{ id: value, name: getValueWithoutId(globalData.offers[value]) }"
            ></gtd-ui-field-dynamic>
            <gtd-ui-field-dynamic
              *ngSwitchCase="'Affiliate'"
              [type]="'affiliate_without_all'"
              [data]="{ id: value, name: getValueWithoutId(globalData.affiliates[value]) }"
            ></gtd-ui-field-dynamic>
            <gtd-ui-field-dynamic
              *ngSwitchCase="'Advertiser'"
              [type]="'advertiser'"
              [data]="{ id: value, name: getValueWithoutId(globalData.advertisers[value]) }"
            ></gtd-ui-field-dynamic>
            <gtd-ui-field-dynamic
              *ngSwitchCase="'Payout Model'"
              [type]="'payout_model'"
              [data]="{ id: value, name: getValueWithoutId(globalData.payout_type[value]) }"
            ></gtd-ui-field-dynamic>
            <gtd-ui-field-dynamic
              *ngSwitchCase="'Revenue Model'"
              [type]="'revenue_model'"
              [data]="{ id: value, name: getValueWithoutId(globalData.revenue_type[value]) }"
            ></gtd-ui-field-dynamic>
            <gtd-ui-field-default-string-or-empty
              *ngSwitchCase="'Transaction Type'"
              [data]="globalData.transaction_types[value]"
            ></gtd-ui-field-default-string-or-empty>
            <gtd-ui-field-default-string-or-empty
              *ngSwitchCase="'Goal Type'"
              [data]="globalData.goal_types[value]"
            ></gtd-ui-field-default-string-or-empty>
            <gtd-ui-field-default-string-or-empty *ngSwitchDefault [data]="value"></gtd-ui-field-default-string-or-empty>
          </span>
        </ng-container>
      </ng-container>
      <span *ngIf="booleanFields.has(data?.field)" class="ml-4 c-card__condition" [ngClass]="conditionsData.length > 1 ? '-with-more' : ''">
        <gtd-ui-field-default-boolean [data]="data?.values[0]"></gtd-ui-field-default-boolean>
      </span>
    </div>
  </ng-container>
  <ng-template #emptyTmpl>&nbsp;</ng-template>
</ng-template>

<ng-template #buttonTmpl></ng-template>
<ng-template let-open="open" #previewTmpl>
  <div class="c-field-value c-field-value--view-mode d-flex">
    <span class="c-field-value__icon" (click)="open($event)">
      <p500-ui-icon name="menu-eye"></p500-ui-icon>
    </span>
    <span>{{ text }}</span>
  </div>
</ng-template>
